import { Switch, Redirect, Route, useLocation, useParams } from 'react-router-dom'
import { Loader } from '@components'
import { DatasetQueryContextProvider } from '@datasets/dataset-query-context'
import { ApprovalRequestsTable, ReviewApprovalRequest } from './components'
import { useApprovalContext, CommentsContextProvider } from './contexts'

interface ApprovalRouterParams {
  id?: string
  datasetId?: string
}

export const Approval = () => {
  const { pathname } = useLocation()
  const params = useParams<ApprovalRouterParams>()
  const { reviewingRequest } = useApprovalContext() ?? { reviewingRequest: null }

  const onTemplateDetailsView = pathname.includes('/template')

  const approvalRequestsTablePath = onTemplateDetailsView
    ? '/template/:id/approval'
    : '/codes/approval'

  const reviewApprovalRequestPath = onTemplateDetailsView
    ? '/template/:id/approval/:datasetId/review'
    : '/codes/approval/:datasetId/review'

  /* 
    If current path is:
     - "/template/:id/approval/:datasetId/review" OR
     - "/codes/approval/:datasetId/review"
    show a loader until the state is updated in context.
  */
  if (params.datasetId && reviewingRequest === null) {
    return <Loader />
  }

  return (
    <Switch>
      <Route exact path={approvalRequestsTablePath}>
        <ApprovalRequestsTable />
      </Route>
      <Route exact path={reviewApprovalRequestPath}>
        {reviewingRequest === null || typeof params.datasetId !== 'string' ? (
          <Redirect to={approvalRequestsTablePath} />
        ) : (
          <DatasetQueryContextProvider datasetId={params.datasetId}>
            <CommentsContextProvider datasetId={params.datasetId}>
              <ReviewApprovalRequest />
            </CommentsContextProvider>
          </DatasetQueryContextProvider>
        )}
      </Route>
    </Switch>
  )
}
